import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const EASE = [0.16, 1, 0.3, 1];

const lineVariants = {
  hidden: { y: "110%" },
  show: (i) => ({ y: 0, transition: { duration: 1, delay: i * 0.13, ease: EASE } }),
};

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0, inView = false }) => {
  const observerProps = inView
    ? { whileInView: "show", viewport: { once: true, margin: "-10%" } }
    : { animate: "show" };
  return (
    <motion.span
      className={`block ${className}`}
      initial="hidden"
      custom={0}
      transition={{ delayChildren: delay, staggerChildren: 0.13 }}
      {...observerProps}
    >
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span custom={i + delay / 0.13} variants={lineVariants} className={`block will-change-transform ${lineClassName}`}>
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const FadeUp = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-8%" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const ParallaxImage = ({ src, alt, className = "", imgClassName = "", speed = 0.12 }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [`-${speed * 100}%`, `${speed * 100}%`]);
  return (
    <div ref={ref} className={`img-frame relative ${className}`}>
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        style={{ y }}
        className={`absolute inset-0 h-[130%] w-full object-cover -top-[15%] ${imgClassName}`}
      />
    </div>
  );
};
